// "Why a No-Code AI Worker Doesn't Kill My Product" — company-brain positioning short.
// Opinion piece for technical founders/CTOs. ~122s @ 30fps.
// Grounded in EAKC-MVP + docs/visual-companion/2026-05-27-eakc-company-brain-positioning.html.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; keep contiguous (next.start = prev end).
export const SCENE = {
  hook: { start: 0, duration: 180 }, //        0:00–0:06  the founder's fear
  reframe: { start: 180, duration: 480 }, //   0:06–0:22  the phone vs the memory
  overlap: { start: 660, duration: 540 }, //   0:22–0:40  where each one structurally lives
  moat: { start: 1200, duration: 540 }, //     0:40–0:58  what a no-code worker can't do
  proof: { start: 1740, duration: 600 }, //    0:58–1:18  it's already built (MCP, 14 tools)
  gateway: { start: 2340, duration: 540 }, //  1:18–1:36  the move — be the brain (QUEUED tag)
  honesty: { start: 2880, duration: 480 }, //  1:36–1:44  shipped vs queued, honestly
  outro: { start: 3360, duration: 300 }, //    1:44–1:54
} as const;

export const TOTAL_DURATION = 3660; // 122s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
